module.exports = __webpack_public_path__ + "img/autito_xmas.41da0a8e.webp";